module.exports = __webpack_public_path__ + "static/media/petanque.1767e98c.svg";